import { Box } from '@factorialco/deprecated-design-system'
import {
  DataTableFilter,
  ExpensesExpensableFilter,
  FilterType,
} from 'generated/resources/datatable.graphql'
import { LegalEntityForSelectFragment } from 'generated/resources/graphql'

import useFilter from 'modules/core/components/Filter/base/useFilter'
import { LegalEntitySelector } from 'modules/core/components/LegalEntitySelector'
import i18n from 'modules/core/lib/i18n'

import type { BaseFilterProps } from './types'
import { trackFilters } from './utils'

const LegalEntityFilterComponent = () => {
  const { value, onValueChange } = useFilter<LegalEntityForSelectFragment[]>()

  return (
    <Box width="s400" flexDirection="column" overflowY="hidden" overflowX="hidden" hideScrollBar>
      <LegalEntitySelector
        width="s400"
        multiple
        hideBorder
        alwaysOpen
        label={''}
        value={value ?? []}
        onChange={onValueChange}
      />
    </Box>
  )
}

const legalEntityFilter = ({
  expensesContext,
  initialFilterValues,
}: BaseFilterProps): DataTableFilter<ExpensesExpensableFilter> => {
  return {
    type: FilterType.Entity,
    categories: [
      {
        kind: 'Entity',
        operation: 'in',
        nameAttribute: 'legalName',
        component: () => <LegalEntityFilterComponent />,
        value: initialFilterValues?.legalEntities,
      },
    ],
    onUpdateValue: () => {
      trackFilters('legalEntity', expensesContext)
    },
    identifier: 'expensesList.legalEntityFilter',
    path: 'legalEntity',
    title: i18n.t('expenses_v2.list.filters.label_legal_entity'),
    default: !!initialFilterValues?.legalEntities,
  }
}

export default legalEntityFilter
